/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as authTermsRouteImport } from './routes/(auth)/terms'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authShopSignUpRouteImport } from './routes/(auth)/shop-sign-up'
import { Route as authPrivacyRouteImport } from './routes/(auth)/privacy'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as AuthenticatedAdministratorRouteRouteImport } from './routes/_authenticated/administrator/route'
import { Route as AuthenticatedMenuIndexRouteImport } from './routes/_authenticated/menu/index'
import { Route as AuthenticatedMenuEditorIndexRouteImport } from './routes/_authenticated/menu-editor/index'

const AuthenticatedUpgradeAccountLazyRouteImport = createFileRoute(
  '/_authenticated/upgrade-account',
)()
const AuthenticatedImageToMenuLazyRouteImport = createFileRoute(
  '/_authenticated/image-to-menu',
)()
const AuthenticatedCreateShopLazyRouteImport = createFileRoute(
  '/_authenticated/create-shop',
)()
const errors503LazyRouteImport = createFileRoute('/(errors)/503')()
const errors500LazyRouteImport = createFileRoute('/(errors)/500')()
const errors404LazyRouteImport = createFileRoute('/(errors)/404')()
const errors403LazyRouteImport = createFileRoute('/(errors)/403')()
const errors401LazyRouteImport = createFileRoute('/(errors)/401')()
const authSignUpLazyRouteImport = createFileRoute('/(auth)/sign-up')()
const authSignIn2LazyRouteImport = createFileRoute('/(auth)/sign-in-2')()
const authResetPasswordLazyRouteImport = createFileRoute(
  '/(auth)/reset-password',
)()
const authForgotPasswordLazyRouteImport = createFileRoute(
  '/(auth)/forgot-password',
)()
const AuthenticatedSettingsRouteLazyRouteImport = createFileRoute(
  '/_authenticated/settings',
)()
const AuthenticatedUsersIndexLazyRouteImport = createFileRoute(
  '/_authenticated/users/',
)()
const AuthenticatedTasksIndexLazyRouteImport = createFileRoute(
  '/_authenticated/tasks/',
)()
const AuthenticatedSettingsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/settings/',
)()
const AuthenticatedQrIndexLazyRouteImport = createFileRoute(
  '/_authenticated/qr/',
)()
const AuthenticatedHelpCenterIndexLazyRouteImport = createFileRoute(
  '/_authenticated/help-center/',
)()
const AuthenticatedChatsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/chats/',
)()
const AuthenticatedAppsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/apps/',
)()
const AuthenticatedAnalyticsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/analytics/',
)()
const AuthenticatedAdministratorIndexLazyRouteImport = createFileRoute(
  '/_authenticated/administrator/',
)()
const AuthenticatedShopsNewLazyRouteImport = createFileRoute(
  '/_authenticated/shops/new',
)()
const AuthenticatedSettingsShopLazyRouteImport = createFileRoute(
  '/_authenticated/settings/shop',
)()
const AuthenticatedSettingsSecurityLazyRouteImport = createFileRoute(
  '/_authenticated/settings/security',
)()
const AuthenticatedSettingsOrganizationLazyRouteImport = createFileRoute(
  '/_authenticated/settings/organization',
)()
const AuthenticatedSettingsNotificationsLazyRouteImport = createFileRoute(
  '/_authenticated/settings/notifications',
)()
const AuthenticatedSettingsDisplayLazyRouteImport = createFileRoute(
  '/_authenticated/settings/display',
)()
const AuthenticatedSettingsBillingLazyRouteImport = createFileRoute(
  '/_authenticated/settings/billing',
)()
const AuthenticatedSettingsAccountLazyRouteImport = createFileRoute(
  '/_authenticated/settings/account',
)()
const AuthenticatedAppsPluginSlugLazyRouteImport = createFileRoute(
  '/_authenticated/apps/$pluginSlug',
)()

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedUpgradeAccountLazyRoute =
  AuthenticatedUpgradeAccountLazyRouteImport.update({
    id: '/upgrade-account',
    path: '/upgrade-account',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/upgrade-account.lazy').then((d) => d.Route),
  )
const AuthenticatedImageToMenuLazyRoute =
  AuthenticatedImageToMenuLazyRouteImport.update({
    id: '/image-to-menu',
    path: '/image-to-menu',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/image-to-menu.lazy').then((d) => d.Route),
  )
const AuthenticatedCreateShopLazyRoute =
  AuthenticatedCreateShopLazyRouteImport.update({
    id: '/create-shop',
    path: '/create-shop',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/create-shop.lazy').then((d) => d.Route),
  )
const errors503LazyRoute = errors503LazyRouteImport
  .update({
    id: '/(errors)/503',
    path: '/503',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/503.lazy').then((d) => d.Route))
const errors500LazyRoute = errors500LazyRouteImport
  .update({
    id: '/(errors)/500',
    path: '/500',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/500.lazy').then((d) => d.Route))
const errors404LazyRoute = errors404LazyRouteImport
  .update({
    id: '/(errors)/404',
    path: '/404',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/404.lazy').then((d) => d.Route))
const errors403LazyRoute = errors403LazyRouteImport
  .update({
    id: '/(errors)/403',
    path: '/403',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/403.lazy').then((d) => d.Route))
const errors401LazyRoute = errors401LazyRouteImport
  .update({
    id: '/(errors)/401',
    path: '/401',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/401.lazy').then((d) => d.Route))
const authSignUpLazyRoute = authSignUpLazyRouteImport
  .update({
    id: '/(auth)/sign-up',
    path: '/sign-up',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(auth)/sign-up.lazy').then((d) => d.Route))
const authSignIn2LazyRoute = authSignIn2LazyRouteImport
  .update({
    id: '/(auth)/sign-in-2',
    path: '/sign-in-2',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(auth)/sign-in-2.lazy').then((d) => d.Route))
const authResetPasswordLazyRoute = authResetPasswordLazyRouteImport
  .update({
    id: '/(auth)/reset-password',
    path: '/reset-password',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() =>
    import('./routes/(auth)/reset-password.lazy').then((d) => d.Route),
  )
const authForgotPasswordLazyRoute = authForgotPasswordLazyRouteImport
  .update({
    id: '/(auth)/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() =>
    import('./routes/(auth)/forgot-password.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsRouteLazyRoute =
  AuthenticatedSettingsRouteLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/route.lazy').then((d) => d.Route),
  )
const authTermsRoute = authTermsRouteImport.update({
  id: '/(auth)/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authShopSignUpRoute = authShopSignUpRouteImport.update({
  id: '/(auth)/shop-sign-up',
  path: '/shop-sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authPrivacyRoute = authPrivacyRouteImport.update({
  id: '/(auth)/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdministratorRouteRoute =
  AuthenticatedAdministratorRouteRouteImport.update({
    id: '/administrator',
    path: '/administrator',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexLazyRoute =
  AuthenticatedUsersIndexLazyRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/users/index.lazy').then((d) => d.Route),
  )
const AuthenticatedTasksIndexLazyRoute =
  AuthenticatedTasksIndexLazyRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/tasks/index.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsIndexLazyRoute =
  AuthenticatedSettingsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/index.lazy').then((d) => d.Route),
  )
const AuthenticatedQrIndexLazyRoute =
  AuthenticatedQrIndexLazyRouteImport.update({
    id: '/qr/',
    path: '/qr/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/qr/index.lazy').then((d) => d.Route),
  )
const AuthenticatedHelpCenterIndexLazyRoute =
  AuthenticatedHelpCenterIndexLazyRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/help-center/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedChatsIndexLazyRoute =
  AuthenticatedChatsIndexLazyRouteImport.update({
    id: '/chats/',
    path: '/chats/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/chats/index.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsIndexLazyRoute =
  AuthenticatedAppsIndexLazyRouteImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/index.lazy').then((d) => d.Route),
  )
const AuthenticatedAnalyticsIndexLazyRoute =
  AuthenticatedAnalyticsIndexLazyRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/analytics/index.lazy').then((d) => d.Route),
  )
const AuthenticatedAdministratorIndexLazyRoute =
  AuthenticatedAdministratorIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdministratorRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/administrator/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMenuIndexRoute = AuthenticatedMenuIndexRouteImport.update({
  id: '/menu/',
  path: '/menu/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/menu/index.lazy').then((d) => d.Route),
)
const AuthenticatedMenuEditorIndexRoute =
  AuthenticatedMenuEditorIndexRouteImport.update({
    id: '/menu-editor/',
    path: '/menu-editor/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/menu-editor/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedShopsNewLazyRoute =
  AuthenticatedShopsNewLazyRouteImport.update({
    id: '/shops/new',
    path: '/shops/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/shops/new.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsShopLazyRoute =
  AuthenticatedSettingsShopLazyRouteImport.update({
    id: '/shop',
    path: '/shop',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/shop.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsSecurityLazyRoute =
  AuthenticatedSettingsSecurityLazyRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/security.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsOrganizationLazyRoute =
  AuthenticatedSettingsOrganizationLazyRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/organization.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsNotificationsLazyRoute =
  AuthenticatedSettingsNotificationsLazyRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/notifications.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsDisplayLazyRoute =
  AuthenticatedSettingsDisplayLazyRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/display.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsBillingLazyRoute =
  AuthenticatedSettingsBillingLazyRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/billing.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAccountLazyRoute =
  AuthenticatedSettingsAccountLazyRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/account.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAppsPluginSlugLazyRoute =
  AuthenticatedAppsPluginSlugLazyRouteImport.update({
    id: '/apps/$pluginSlug',
    path: '/apps/$pluginSlug',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/$pluginSlug.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/administrator': typeof AuthenticatedAdministratorRouteRouteWithChildren
  '/otp': typeof authOtpRoute
  '/privacy': typeof authPrivacyRoute
  '/shop-sign-up': typeof authShopSignUpRoute
  '/sign-in': typeof authSignInRoute
  '/terms': typeof authTermsRoute
  '/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/reset-password': typeof authResetPasswordLazyRoute
  '/sign-in-2': typeof authSignIn2LazyRoute
  '/sign-up': typeof authSignUpLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/create-shop': typeof AuthenticatedCreateShopLazyRoute
  '/image-to-menu': typeof AuthenticatedImageToMenuLazyRoute
  '/upgrade-account': typeof AuthenticatedUpgradeAccountLazyRoute
  '/apps/$pluginSlug': typeof AuthenticatedAppsPluginSlugLazyRoute
  '/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingLazyRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationLazyRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityLazyRoute
  '/settings/shop': typeof AuthenticatedSettingsShopLazyRoute
  '/shops/new': typeof AuthenticatedShopsNewLazyRoute
  '/menu-editor/': typeof AuthenticatedMenuEditorIndexRoute
  '/menu/': typeof AuthenticatedMenuIndexRoute
  '/administrator/': typeof AuthenticatedAdministratorIndexLazyRoute
  '/analytics/': typeof AuthenticatedAnalyticsIndexLazyRoute
  '/apps/': typeof AuthenticatedAppsIndexLazyRoute
  '/chats/': typeof AuthenticatedChatsIndexLazyRoute
  '/help-center/': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/qr/': typeof AuthenticatedQrIndexLazyRoute
  '/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/tasks/': typeof AuthenticatedTasksIndexLazyRoute
  '/users/': typeof AuthenticatedUsersIndexLazyRoute
}
export interface FileRoutesByTo {
  '/otp': typeof authOtpRoute
  '/privacy': typeof authPrivacyRoute
  '/shop-sign-up': typeof authShopSignUpRoute
  '/sign-in': typeof authSignInRoute
  '/terms': typeof authTermsRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/reset-password': typeof authResetPasswordLazyRoute
  '/sign-in-2': typeof authSignIn2LazyRoute
  '/sign-up': typeof authSignUpLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/create-shop': typeof AuthenticatedCreateShopLazyRoute
  '/image-to-menu': typeof AuthenticatedImageToMenuLazyRoute
  '/upgrade-account': typeof AuthenticatedUpgradeAccountLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/apps/$pluginSlug': typeof AuthenticatedAppsPluginSlugLazyRoute
  '/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingLazyRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationLazyRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityLazyRoute
  '/settings/shop': typeof AuthenticatedSettingsShopLazyRoute
  '/shops/new': typeof AuthenticatedShopsNewLazyRoute
  '/menu-editor': typeof AuthenticatedMenuEditorIndexRoute
  '/menu': typeof AuthenticatedMenuIndexRoute
  '/administrator': typeof AuthenticatedAdministratorIndexLazyRoute
  '/analytics': typeof AuthenticatedAnalyticsIndexLazyRoute
  '/apps': typeof AuthenticatedAppsIndexLazyRoute
  '/chats': typeof AuthenticatedChatsIndexLazyRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/qr': typeof AuthenticatedQrIndexLazyRoute
  '/settings': typeof AuthenticatedSettingsIndexLazyRoute
  '/tasks': typeof AuthenticatedTasksIndexLazyRoute
  '/users': typeof AuthenticatedUsersIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/administrator': typeof AuthenticatedAdministratorRouteRouteWithChildren
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/privacy': typeof authPrivacyRoute
  '/(auth)/shop-sign-up': typeof authShopSignUpRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/terms': typeof authTermsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordLazyRoute
  '/(auth)/reset-password': typeof authResetPasswordLazyRoute
  '/(auth)/sign-in-2': typeof authSignIn2LazyRoute
  '/(auth)/sign-up': typeof authSignUpLazyRoute
  '/(errors)/401': typeof errors401LazyRoute
  '/(errors)/403': typeof errors403LazyRoute
  '/(errors)/404': typeof errors404LazyRoute
  '/(errors)/500': typeof errors500LazyRoute
  '/(errors)/503': typeof errors503LazyRoute
  '/_authenticated/create-shop': typeof AuthenticatedCreateShopLazyRoute
  '/_authenticated/image-to-menu': typeof AuthenticatedImageToMenuLazyRoute
  '/_authenticated/upgrade-account': typeof AuthenticatedUpgradeAccountLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/apps/$pluginSlug': typeof AuthenticatedAppsPluginSlugLazyRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingLazyRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/_authenticated/settings/organization': typeof AuthenticatedSettingsOrganizationLazyRoute
  '/_authenticated/settings/security': typeof AuthenticatedSettingsSecurityLazyRoute
  '/_authenticated/settings/shop': typeof AuthenticatedSettingsShopLazyRoute
  '/_authenticated/shops/new': typeof AuthenticatedShopsNewLazyRoute
  '/_authenticated/menu-editor/': typeof AuthenticatedMenuEditorIndexRoute
  '/_authenticated/menu/': typeof AuthenticatedMenuIndexRoute
  '/_authenticated/administrator/': typeof AuthenticatedAdministratorIndexLazyRoute
  '/_authenticated/analytics/': typeof AuthenticatedAnalyticsIndexLazyRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexLazyRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexLazyRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/_authenticated/qr/': typeof AuthenticatedQrIndexLazyRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexLazyRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/administrator'
    | '/otp'
    | '/privacy'
    | '/shop-sign-up'
    | '/sign-in'
    | '/terms'
    | '/settings'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/create-shop'
    | '/image-to-menu'
    | '/upgrade-account'
    | '/apps/$pluginSlug'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/display'
    | '/settings/notifications'
    | '/settings/organization'
    | '/settings/security'
    | '/settings/shop'
    | '/shops/new'
    | '/menu-editor/'
    | '/menu/'
    | '/administrator/'
    | '/analytics/'
    | '/apps/'
    | '/chats/'
    | '/help-center/'
    | '/qr/'
    | '/settings/'
    | '/tasks/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/otp'
    | '/privacy'
    | '/shop-sign-up'
    | '/sign-in'
    | '/terms'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/create-shop'
    | '/image-to-menu'
    | '/upgrade-account'
    | '/'
    | '/apps/$pluginSlug'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/display'
    | '/settings/notifications'
    | '/settings/organization'
    | '/settings/security'
    | '/settings/shop'
    | '/shops/new'
    | '/menu-editor'
    | '/menu'
    | '/administrator'
    | '/analytics'
    | '/apps'
    | '/chats'
    | '/help-center'
    | '/qr'
    | '/settings'
    | '/tasks'
    | '/users'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/administrator'
    | '/(auth)/otp'
    | '/(auth)/privacy'
    | '/(auth)/shop-sign-up'
    | '/(auth)/sign-in'
    | '/(auth)/terms'
    | '/_authenticated/settings'
    | '/(auth)/forgot-password'
    | '/(auth)/reset-password'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/create-shop'
    | '/_authenticated/image-to-menu'
    | '/_authenticated/upgrade-account'
    | '/_authenticated/'
    | '/_authenticated/apps/$pluginSlug'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/organization'
    | '/_authenticated/settings/security'
    | '/_authenticated/settings/shop'
    | '/_authenticated/shops/new'
    | '/_authenticated/menu-editor/'
    | '/_authenticated/menu/'
    | '/_authenticated/administrator/'
    | '/_authenticated/analytics/'
    | '/_authenticated/apps/'
    | '/_authenticated/chats/'
    | '/_authenticated/help-center/'
    | '/_authenticated/qr/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  authOtpRoute: typeof authOtpRoute
  authPrivacyRoute: typeof authPrivacyRoute
  authShopSignUpRoute: typeof authShopSignUpRoute
  authSignInRoute: typeof authSignInRoute
  authTermsRoute: typeof authTermsRoute
  authForgotPasswordLazyRoute: typeof authForgotPasswordLazyRoute
  authResetPasswordLazyRoute: typeof authResetPasswordLazyRoute
  authSignIn2LazyRoute: typeof authSignIn2LazyRoute
  authSignUpLazyRoute: typeof authSignUpLazyRoute
  errors401LazyRoute: typeof errors401LazyRoute
  errors403LazyRoute: typeof errors403LazyRoute
  errors404LazyRoute: typeof errors404LazyRoute
  errors500LazyRoute: typeof errors500LazyRoute
  errors503LazyRoute: typeof errors503LazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/upgrade-account': {
      id: '/_authenticated/upgrade-account'
      path: '/upgrade-account'
      fullPath: '/upgrade-account'
      preLoaderRoute: typeof AuthenticatedUpgradeAccountLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/image-to-menu': {
      id: '/_authenticated/image-to-menu'
      path: '/image-to-menu'
      fullPath: '/image-to-menu'
      preLoaderRoute: typeof AuthenticatedImageToMenuLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/create-shop': {
      id: '/_authenticated/create-shop'
      path: '/create-shop'
      fullPath: '/create-shop'
      preLoaderRoute: typeof AuthenticatedCreateShopLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(auth)/terms': {
      id: '/(auth)/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof authTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/shop-sign-up': {
      id: '/(auth)/shop-sign-up'
      path: '/shop-sign-up'
      fullPath: '/shop-sign-up'
      preLoaderRoute: typeof authShopSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/privacy': {
      id: '/(auth)/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof authPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/administrator': {
      id: '/_authenticated/administrator'
      path: '/administrator'
      fullPath: '/administrator'
      preLoaderRoute: typeof AuthenticatedAdministratorRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/qr/': {
      id: '/_authenticated/qr/'
      path: '/qr'
      fullPath: '/qr/'
      preLoaderRoute: typeof AuthenticatedQrIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center/'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats/'
      preLoaderRoute: typeof AuthenticatedChatsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AuthenticatedAppsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/analytics/': {
      id: '/_authenticated/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthenticatedAnalyticsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/administrator/': {
      id: '/_authenticated/administrator/'
      path: '/'
      fullPath: '/administrator/'
      preLoaderRoute: typeof AuthenticatedAdministratorIndexLazyRouteImport
      parentRoute: typeof AuthenticatedAdministratorRouteRoute
    }
    '/_authenticated/menu/': {
      id: '/_authenticated/menu/'
      path: '/menu'
      fullPath: '/menu/'
      preLoaderRoute: typeof AuthenticatedMenuIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/menu-editor/': {
      id: '/_authenticated/menu-editor/'
      path: '/menu-editor'
      fullPath: '/menu-editor/'
      preLoaderRoute: typeof AuthenticatedMenuEditorIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/shops/new': {
      id: '/_authenticated/shops/new'
      path: '/shops/new'
      fullPath: '/shops/new'
      preLoaderRoute: typeof AuthenticatedShopsNewLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/shop': {
      id: '/_authenticated/settings/shop'
      path: '/shop'
      fullPath: '/settings/shop'
      preLoaderRoute: typeof AuthenticatedSettingsShopLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/security': {
      id: '/_authenticated/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/organization': {
      id: '/_authenticated/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedSettingsBillingLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/apps/$pluginSlug': {
      id: '/_authenticated/apps/$pluginSlug'
      path: '/apps/$pluginSlug'
      fullPath: '/apps/$pluginSlug'
      preLoaderRoute: typeof AuthenticatedAppsPluginSlugLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedAdministratorRouteRouteChildren {
  AuthenticatedAdministratorIndexLazyRoute: typeof AuthenticatedAdministratorIndexLazyRoute
}

const AuthenticatedAdministratorRouteRouteChildren: AuthenticatedAdministratorRouteRouteChildren =
  {
    AuthenticatedAdministratorIndexLazyRoute:
      AuthenticatedAdministratorIndexLazyRoute,
  }

const AuthenticatedAdministratorRouteRouteWithChildren =
  AuthenticatedAdministratorRouteRoute._addFileChildren(
    AuthenticatedAdministratorRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteLazyRouteChildren {
  AuthenticatedSettingsAccountLazyRoute: typeof AuthenticatedSettingsAccountLazyRoute
  AuthenticatedSettingsBillingLazyRoute: typeof AuthenticatedSettingsBillingLazyRoute
  AuthenticatedSettingsDisplayLazyRoute: typeof AuthenticatedSettingsDisplayLazyRoute
  AuthenticatedSettingsNotificationsLazyRoute: typeof AuthenticatedSettingsNotificationsLazyRoute
  AuthenticatedSettingsOrganizationLazyRoute: typeof AuthenticatedSettingsOrganizationLazyRoute
  AuthenticatedSettingsSecurityLazyRoute: typeof AuthenticatedSettingsSecurityLazyRoute
  AuthenticatedSettingsShopLazyRoute: typeof AuthenticatedSettingsShopLazyRoute
  AuthenticatedSettingsIndexLazyRoute: typeof AuthenticatedSettingsIndexLazyRoute
}

const AuthenticatedSettingsRouteLazyRouteChildren: AuthenticatedSettingsRouteLazyRouteChildren =
  {
    AuthenticatedSettingsAccountLazyRoute:
      AuthenticatedSettingsAccountLazyRoute,
    AuthenticatedSettingsBillingLazyRoute:
      AuthenticatedSettingsBillingLazyRoute,
    AuthenticatedSettingsDisplayLazyRoute:
      AuthenticatedSettingsDisplayLazyRoute,
    AuthenticatedSettingsNotificationsLazyRoute:
      AuthenticatedSettingsNotificationsLazyRoute,
    AuthenticatedSettingsOrganizationLazyRoute:
      AuthenticatedSettingsOrganizationLazyRoute,
    AuthenticatedSettingsSecurityLazyRoute:
      AuthenticatedSettingsSecurityLazyRoute,
    AuthenticatedSettingsShopLazyRoute: AuthenticatedSettingsShopLazyRoute,
    AuthenticatedSettingsIndexLazyRoute: AuthenticatedSettingsIndexLazyRoute,
  }

const AuthenticatedSettingsRouteLazyRouteWithChildren =
  AuthenticatedSettingsRouteLazyRoute._addFileChildren(
    AuthenticatedSettingsRouteLazyRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdministratorRouteRoute: typeof AuthenticatedAdministratorRouteRouteWithChildren
  AuthenticatedSettingsRouteLazyRoute: typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  AuthenticatedCreateShopLazyRoute: typeof AuthenticatedCreateShopLazyRoute
  AuthenticatedImageToMenuLazyRoute: typeof AuthenticatedImageToMenuLazyRoute
  AuthenticatedUpgradeAccountLazyRoute: typeof AuthenticatedUpgradeAccountLazyRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAppsPluginSlugLazyRoute: typeof AuthenticatedAppsPluginSlugLazyRoute
  AuthenticatedShopsNewLazyRoute: typeof AuthenticatedShopsNewLazyRoute
  AuthenticatedMenuEditorIndexRoute: typeof AuthenticatedMenuEditorIndexRoute
  AuthenticatedMenuIndexRoute: typeof AuthenticatedMenuIndexRoute
  AuthenticatedAnalyticsIndexLazyRoute: typeof AuthenticatedAnalyticsIndexLazyRoute
  AuthenticatedAppsIndexLazyRoute: typeof AuthenticatedAppsIndexLazyRoute
  AuthenticatedChatsIndexLazyRoute: typeof AuthenticatedChatsIndexLazyRoute
  AuthenticatedHelpCenterIndexLazyRoute: typeof AuthenticatedHelpCenterIndexLazyRoute
  AuthenticatedQrIndexLazyRoute: typeof AuthenticatedQrIndexLazyRoute
  AuthenticatedTasksIndexLazyRoute: typeof AuthenticatedTasksIndexLazyRoute
  AuthenticatedUsersIndexLazyRoute: typeof AuthenticatedUsersIndexLazyRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdministratorRouteRoute:
    AuthenticatedAdministratorRouteRouteWithChildren,
  AuthenticatedSettingsRouteLazyRoute:
    AuthenticatedSettingsRouteLazyRouteWithChildren,
  AuthenticatedCreateShopLazyRoute: AuthenticatedCreateShopLazyRoute,
  AuthenticatedImageToMenuLazyRoute: AuthenticatedImageToMenuLazyRoute,
  AuthenticatedUpgradeAccountLazyRoute: AuthenticatedUpgradeAccountLazyRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAppsPluginSlugLazyRoute: AuthenticatedAppsPluginSlugLazyRoute,
  AuthenticatedShopsNewLazyRoute: AuthenticatedShopsNewLazyRoute,
  AuthenticatedMenuEditorIndexRoute: AuthenticatedMenuEditorIndexRoute,
  AuthenticatedMenuIndexRoute: AuthenticatedMenuIndexRoute,
  AuthenticatedAnalyticsIndexLazyRoute: AuthenticatedAnalyticsIndexLazyRoute,
  AuthenticatedAppsIndexLazyRoute: AuthenticatedAppsIndexLazyRoute,
  AuthenticatedChatsIndexLazyRoute: AuthenticatedChatsIndexLazyRoute,
  AuthenticatedHelpCenterIndexLazyRoute: AuthenticatedHelpCenterIndexLazyRoute,
  AuthenticatedQrIndexLazyRoute: AuthenticatedQrIndexLazyRoute,
  AuthenticatedTasksIndexLazyRoute: AuthenticatedTasksIndexLazyRoute,
  AuthenticatedUsersIndexLazyRoute: AuthenticatedUsersIndexLazyRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  authOtpRoute: authOtpRoute,
  authPrivacyRoute: authPrivacyRoute,
  authShopSignUpRoute: authShopSignUpRoute,
  authSignInRoute: authSignInRoute,
  authTermsRoute: authTermsRoute,
  authForgotPasswordLazyRoute: authForgotPasswordLazyRoute,
  authResetPasswordLazyRoute: authResetPasswordLazyRoute,
  authSignIn2LazyRoute: authSignIn2LazyRoute,
  authSignUpLazyRoute: authSignUpLazyRoute,
  errors401LazyRoute: errors401LazyRoute,
  errors403LazyRoute: errors403LazyRoute,
  errors404LazyRoute: errors404LazyRoute,
  errors500LazyRoute: errors500LazyRoute,
  errors503LazyRoute: errors503LazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
